<div class="flex flex-flat">
  <mat-form-field appearance="outline" class="max-width" [ngClass]="{'mat-custom-focus': isOpen, 'mat-custom-error': showError,
                  'with-suffix': allowDateClear || timepicker, 'small': small, 'no-hint': !showHint && noHint, 'responsive-hint': showHint}">
    <mat-label *ngIf="label && (!disabled || this.date)">{{ label | translate }}</mat-label>
    <input matInput type="text" [value]="'true'" class="hide" [required]="required" [disabled]="disabled">
    <div class="custom-datepicker-button-wrapper">
      <div class="custom-datepicker-button" (click)="open()" [ngClass]="{'open': isOpen}">
        <span class="preset" *ngIf="!noPresets && !disabled">{{ calendarLabel }}</span>
        <ng-container *ngIf="range">
          <span [ngClass]="{'text-muted' : lockStart}">{{ getCalendarRange() }}</span>
          <span>{{getCalendarRange(false)}}</span>
        </ng-container>
        <span *ngIf="!range">
          {{ getCalendarDate }}
          <span class="text-warning muted black" *ngIf="disabled && required">*</span>
        </span>
        <mat-icon class="svg-icon calendar-icon" [ngClass]="{'text-secondary': isOpen}" [svgIcon]="'calendar'"></mat-icon>
      </div>
    </div>
    <mat-hint *ngIf="showHint" [ngClass]="{'text-warning': showError, 'white-space-no-wrap': timepicker}">
      <span class="custom-datepicker-hint" *ngIf="!valid || requiredButEmpty">
        <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
        {{ (errorMessage || 'general.api_datepicker_date_invalid') | translate}}
      </span>
      <span class="custom-datepicker-hint" *ngIf="(showWarning || maxRange) && valid && !requiredButEmpty">
        <mat-icon class="svg-icon" [svgIcon]="maxRangeExceeded ? 'warning' : 'alert'"></mat-icon>
        {{ (showWarning ? (warningMessage || 'general.api_datepicker_warning') : 'general.api_datepicker_max_range') | translate: {maxRange: maxRange} }}
      </span>
    </mat-hint>
  </mat-form-field>
  <app-time-input *ngIf="timepicker" [label]="timeLabel" [(manualTime)]="timeManualChange"
                  [appClass]="showError ? 'mat-custom-error' : ''"
                  [date]="dateField" (dateChange)="setDateFieldFromTime($event)"
                  [(time)]="time" (timeChange)="emitTimeChange($event)"
                  [disabled]="!allowTimeChange && disabled || !date" [valid]="valid && !requiredButEmpty"
                  [withPrefix]="true" [withSuffix]="allowDateClear"
                  [focused]="focusTimePicker"></app-time-input>
  <button mat-button class="clear input-button icon-button suffix-button" type="button" [ngClass]="{'small': small, 'mat-warn': showError}"
          *ngIf="allowDateClear" [disabled]="disabled" (click)="clearDate()">
    <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<mat-form-field appearance="outline" class="custom-datepicker" *ngIf="range">
  <mat-date-range-input [rangePicker]="dateRangePicker" [min]="lockStart ? dateStart : minDate" [max]="maxDate" [disabled]="disabled">
    <input matStartDate [(ngModel)]="dateStartField" [ngModelOptions]="{standalone: true}" (ngModelChange)="isPickerDirty = true">
    <input matEndDate [(ngModel)]="dateEndField" [ngModelOptions]="{standalone: true}" (ngModelChange)="isPickerDirty = true">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
  <mat-date-range-picker #dateRangePicker [calendarHeaderComponent]="customRangeHeader" [lockDate]="getLockDate" (closed)="onClosed()">
    <mat-date-range-picker-actions>
      <ng-container *ngIf="!autoBindDates">
        <button mat-button matDatepickerCancel>{{ 'general.api_datepicker_action_cancel' | translate }}</button>
        <button mat-flat-button color="primary" matDatepickerApply (click)="applyDateRange()">{{ 'general.api_datepicker_action_apply' | translate }}</button>
      </ng-container>
      <button mat-button color="primary" matDatepickerApply *ngIf="autoBindDates" (click)="applyDateRange()">{{ 'general.api_datepicker_action_close' | translate }}</button>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>
<mat-form-field appearance="outline" class="custom-datepicker" *ngIf="!range">
  <input matInput [(ngModel)]="dateField" [ngModelOptions]="{standalone: true}" (ngModelChange)="isPickerDirty = true"
         [matDatepicker]="datePicker" [min]="minDate" [max]="maxDate" [disabled]="disabled || lockStart">
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker #datePicker [calendarHeaderComponent]="customHeader" (closed)="onClosed()">
    <mat-datepicker-actions>
      <ng-container *ngIf="!autoBindDates">
        <button mat-button matDatepickerCancel>{{ 'general.api_datepicker_action_cancel' | translate }}</button>
        <button mat-flat-button color="primary" matDatepickerApply (click)="applyDate()">{{ 'general.api_datepicker_action_apply' | translate }}</button>
      </ng-container>
      <button mat-button color="primary" matDatepickerApply *ngIf="autoBindDates" (click)="applyDate()">{{ 'general.api_datepicker_action_close' | translate }}</button>
    </mat-datepicker-actions>
  </mat-datepicker>
</mat-form-field>
